import { render, staticRenderFns } from "./ClosePriceList.vue?vue&type=template&id=32708080"
import script from "./ClosePriceList.vue?vue&type=script&lang=js"
export * from "./ClosePriceList.vue?vue&type=script&lang=js"
import style0 from "./ClosePriceList.vue?vue&type=style&index=0&id=32708080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports